import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import { createProviderToken } from '@recruitee/common';

import type { PdfViewerConfig, PdfViewerErrorContexts } from './pdf-viewer.types';

export const PDF_VIEWER_CONFIG_TOKEN = new InjectionToken<PdfViewerConfig>(
  'PDF_VIEWER_CONFIG_TOKEN',
);

export const { provide: providePdfViewerErrorContexts, inject: injectPdfViewerErrorContexts } =
  createProviderToken<Observable<PdfViewerErrorContexts>>('Pdf viewer error contexts')();
